import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink, BookOpen } from "lucide-react";

export default function PaperCard({ paper, compact = false }) {
  return (
    <Link
      to={`/publications/${paper.id}`}
      className={`kb-card overflow-hidden group block ${compact ? "" : "flex flex-col"}`}
      data-testid={`paper-card-${paper.id}`}
    >
      {paper.image_url && (
        <div className="aspect-[16/9] bg-slate-100 bg-cover bg-center" style={{ backgroundImage: `url(${paper.image_url})` }} />
      )}
      <div className="p-5 flex-1 flex flex-col">
        <div className="flex items-center gap-2">
          <span className="kb-mono text-[10px] uppercase tracking-wider text-kb-primary bg-kb-primary/5 border border-kb-primary/15 px-2 py-1 rounded-sm">{paper.year}</span>
          {paper.featured && (
            <span className="kb-mono text-[10px] uppercase tracking-wider text-amber-700 bg-amber-50 border border-amber-200 px-2 py-1 rounded-sm">FEATURED</span>
          )}
        </div>
        <h3 className="font-serif text-lg text-kb-ink mt-3 leading-tight line-clamp-2">{paper.title}</h3>
        <div className="kb-mono text-[10px] uppercase tracking-wider text-kb-ink-muted mt-2 line-clamp-1">{paper.authors.join(" · ")}</div>
        <div className="text-xs text-kb-ink-muted mt-1 italic line-clamp-1">{paper.venue}</div>
        {!compact && (
          <p className="text-sm text-kb-ink-muted mt-3 line-clamp-3 leading-relaxed flex-1">{paper.abstract}</p>
        )}
        <div className="mt-4 pt-3 border-t border-slate-200 flex items-center justify-between">
          <div className="flex gap-1.5 flex-wrap">
            {(paper.domain || []).slice(0, 2).map((d) => (
              <span key={d} className="kb-mono text-[10px] uppercase tracking-wider text-kb-ink bg-slate-100 px-2 py-1 rounded-sm">{d}</span>
            ))}
          </div>
          <span className="kb-mono text-[10px] text-kb-primary inline-flex items-center gap-1">
            <BookOpen className="w-3 h-3" /> READ
          </span>
        </div>
      </div>
    </Link>
  );
}
